import React from 'react';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { HowItWorks } from '../components/HowItWorks';
import { ValueProposition } from '../components/ValueProposition';
import { UseCases } from '../components/UseCases';
import { ProductDeepDive } from '../components/ProductDeepDive';
import { TrustSecurity } from '../components/TrustSecurity';
import { Pricing } from '../components/Pricing';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-527">
      <SEO title="KittyPot | No More Chasing Friends for Money" description="KittyPot helps groups track shared expenses, split costs fairly, and see the simplest way to settle up — without awkward chasing." ogTitle="KittyPot | No More Chasing Friends for Money" ogDescription="Track shared expenses, split costs fairly, and see the simplest way to settle up." path="/" jsonLd={{
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'KittyPot',
      url: 'https://www.kittypot.com',
      description: 'KittyPot is a shared expense and settlement tracker. It helps groups track shared expenses, split costs fairly, and see the simplest way to settle up. Current MVP: expense tracking and manual settlement only. KittyPot does not hold or move money.'
    }} data-id="element-528" />
      <Navbar data-id="element-529" />
      <main data-id="element-530">
        <HeroSection data-id="element-531" />
        <ProblemSection data-id="element-532" />
        <HowItWorks data-id="element-533" />
        <ValueProposition data-id="element-534" />
        <UseCases data-id="element-535" />
        <ProductDeepDive data-id="element-536" />
        <Pricing data-id="element-537" />
        <TrustSecurity data-id="element-538" />
        <FinalCTA data-id="element-539" />
      </main>
      <Footer data-id="element-540" />
    </div>;
}